import React, { useState, useRef, useEffect, useCallback } from 'react';

const QUESTION_FILES = {
  he: '/questions_he.txt',
  en: '/questions_en.txt',
};

function getRandomSubset(list, count) {
  if (!Array.isArray(list) || list.length === 0) return [];
  const cappedCount = Math.min(count, list.length);
  const shuffled = [...list];
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, cappedCount);
}

function QuestionForm({ onSubmit, copy = {}, language = 'he' }) {
  const [question, setQuestion] = useState('');
  const [allSuggestions, setAllSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const inputRef = useRef(null);

  const direction = language === 'he' ? 'rtl' : 'ltr';
  const labelText = copy.label || (language === 'he' ? 'כתוב/כתבי את השאלה שלך' : 'Write your question');
  const submitText = copy.submitButton || (language === 'he' ? 'שליחת שאלה' : 'Submit Question');

  useEffect(() => {
    // מיקוד בשדה השאלה עם הטעינה
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    let isActive = true;
    const fetchSuggestions = async () => {
      const filePath = QUESTION_FILES[language] || QUESTION_FILES.en;
      try {
        const response = await fetch(filePath);
        if (!response.ok) {
          throw new Error(`Failed to fetch question suggestions from ${filePath}`);
        }
        const text = await response.text();
        if (!isActive) return;
        const parsed = text
          .split('\n')
          .map((line) => line.trim())
          .filter(Boolean);
        setAllSuggestions(parsed);
        setSuggestions(getRandomSubset(parsed, 3));
      } catch (error) {
        console.error(error);
        if (isActive) {
          setAllSuggestions([]);
          setSuggestions([]);
        }
      }
    };

    fetchSuggestions();

    return () => {
      isActive = false;
    };
  }, [language]);

  const refreshSuggestions = useCallback(() => {
    setSuggestions(getRandomSubset(allSuggestions, 3));
  }, [allSuggestions]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (question.trim() === '') return;
    onSubmit(question);
    setQuestion('');
    refreshSuggestions();
  };

  const handleSuggestionClick = (option) => {
    if (!option) return;
    onSubmit(option);
    setQuestion('');
    refreshSuggestions();
  };

  return (
    <form onSubmit={handleSubmit} dir={direction}>
      <label>
        {labelText}
        <br />
        <input
          type="text"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          ref={inputRef}
          autoFocus
          style={{ width: '80%', padding: '0.5rem', marginTop: '0.5rem' }}
        />
      </label>
      <br />
      <button type="submit" style={{ marginTop: '1rem' }}>{submitText}</button>
      {suggestions.length > 0 && (
        <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          {suggestions.map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => handleSuggestionClick(option)}
              style={{ padding: '0.5rem 1rem', 'background-color':'purple' }}
            >
              {option}
            </button>
          ))}
        </div>
      )}
    </form>
  );
}

export default QuestionForm;

